import { render, staticRenderFns } from "./PaymentPaypalEmbedded.vue?vue&type=template&id=2ebaa98b&scoped=true&"
import script from "./PaymentPaypalEmbedded.vue?vue&type=script&lang=js&"
export * from "./PaymentPaypalEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPaypalEmbedded.vue?vue&type=style&index=0&id=2ebaa98b&lang=stylus&scoped=true&"
import style1 from "./PaymentPaypalEmbedded.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaa98b",
  null
  
)

export default component.exports